/*
функция альтернатива lodash/get
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lodashGet(obj: any, path: string, defaultValue?: any) {
  // Если объект не существует, возвращаем значение по умолчанию
  if (obj === null || obj === undefined) {
    return defaultValue;
  }

  // Разбиваем путь на части
  const keys = path.split('.');
  let current = obj;

  // eslint-disable-next-line no-restricted-syntax
  for (const key of keys) {
    // Обрабатываем массивы с индексами в квадратных скобках
    if (key.includes('[')) {
      const arrayMatch = key.match(/([^[]+)\[(\d+)]/);

      if (arrayMatch) {
        const arrayName = arrayMatch[1];
        // @ts-ignore
        const index = parseInt(arrayMatch[2], 10);

        // Проверяем существование массива и корректность индекса
        if (
          !current[arrayName] ||
          !Array.isArray(current[arrayName]) ||
          index < 0 ||
          index >= current[arrayName].length
        ) {
          return defaultValue;
        }

        current = current[arrayName][index];
        // eslint-disable-next-line no-continue
        continue;
      }
    }

    // Обрабатываем обычные свойства
    if (current?.[key] === undefined || current?.[key] === null) {
      return defaultValue;
    }

    current = current[key];
  }

  return current;
}
